/* eslint-disable max-len */
import React from 'react';

const TitleIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <path
            d="M12 4v1H8v11H7V5H3V4h9zm6 4v1h-3v7h-1V9h-3V8h7z"
            transform="translate(-283.000000, -81.000000) translate(280.000000, 77.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default TitleIcon;
